// Rutas reales de la app (deben reflejar las definidas en App.jsx).
// Cualquier ruta que no esté aquí se considera una página 404 y no debe
// mostrar el navbar, el badge de clientes, WhatsApp ni el chatbot flotante.
export const KNOWN_ROUTES = [
  '/',
  '/login',
  '/register',
  '/chatbot',
  '/panel-admin',
  '/confirmar-correo',
];
